import api from './api';

/**
 * Fetches security notification settings from the backend
 * @returns {Promise<Object>} Security notification settings
 */
export const getSystemLogs = async (params) => {
  try {
    const response = await api.get('/system-logs', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching security notification settings:', error);
    throw error;
  }
};

export default getSystemLogs;
